<template>
  <div class="preview-table">
    <el-table ref="ref_Table" :data="tableData" :span-method="tableSpanMethod" style="width: 100%" border>
      <el-table-column label="项目">
        <template slot="header" slot-scope="scope">
          <div class="table-col-header">
            <h5>项目{{ scope.$index ? '' : '' }}</h5>
            <el-switch v-if="!isV3" v-model="tableForm.projectSwitch"></el-switch>
          </div>
        </template>
        <el-table-column label="项目信息" prop="" width="280">
          <template slot-scope="scope">
            <el-select size="mini" :value="1" style="width: 130px" disabled>
              <el-option
                v-for="item in [{ label: '新建项目', value: 1 }]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <slot name="projectName" v-bind="scope"></slot>
          </template>
        </el-table-column>
        <el-table-column label="项目预算" width="140">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox v-model="tableHeaderForm.projectBudgetCheck" @change="onGlobalCheckChange($event, 'projectBudgetCheck')">
                </el-checkbox>
                <span>&ensp;项目预算</span>
              </div>
              <span class="col-modify" @click="onBudgetModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>
          <template slot-scope="{ row, $index }">
            <el-checkbox v-model="row.projectBudgetCheck"></el-checkbox>
            <el-button @click="onBudgetModify($index)" type="text">
              <span v-if="row.outer_plan_params?.delivery_setting.budget">
                预算： {{ row.outer_plan_params.delivery_setting.budget }}
              </span>
              <span v-else>不限</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="定向包" width="140">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox v-model="tableHeaderForm.projectTargetCheck" @change="onGlobalCheckChange($event, 'projectTargetCheck')">
                </el-checkbox>
                <span>&ensp;定向包</span>
              </div>
              <span class="col-modify" @click="onTargetModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>
          <template slot-scope="{ row, $index }">
            <el-checkbox v-model="row.projectTargetCheck"></el-checkbox>
            <span style="cursor: pointer" @click="onTargetModify($index)">{{ row.targetings.targetingName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="优化目标" width="140">
          <template slot-scope="{ row }">
            <div>优化目标: {{ EXTERNAL_ACTION_LIST.find((item) => item.value === row.outer_plan_params?.external_action).label }}</div>
            <div>
              深度优化方式:
              {{ DEEP_BID_TYPE_LIST.find((item) => item.value === row.outer_plan_params?.delivery_setting.deep_bid_type)?.label || '无' }}
            </div>
            <div>
              深度优化目标:
              {{ DEEP_EXTERNAL_ACTION_LIST.find((item) => item.value === row.outer_plan_params?.deep_external_action).label }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="计划">
        <template slot="header" slot-scope="scope">
          <div class="table-col-header">
            <h5>计划 {{ getAdCount(scope) }}）</h5>
            <el-switch v-if="!isV3" v-model="tableForm.planSwitch"></el-switch>
          </div>
        </template>
        <el-table-column label="全选" align="left" width="45">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a">
              <el-checkbox v-model="tableForm.isCheckAll" @change="onAllCheckChange"> </el-checkbox>
            </div>
          </template>
          <template slot-scope="{ row }">
            <el-checkbox :disabled="row.planRowDisabled" v-model="row.isCheck" @change="onTableRowCheckChange($event, row)"> </el-checkbox>
          </template>
        </el-table-column>
        <el-table-column v-if="!isV3" label="计划名称" prop="inner_plan_params.plan_name" width="260">
          <template slot-scope="scope">
            <slot name="planName" v-bind="scope" :editable="planNameEditable(scope.row, scope.$index)"></slot>
          </template>
        </el-table-column>
        <el-table-column label="预算" width="120" v-if="adBudgetVisible">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox v-model="tableHeaderForm.adBudgetCheck" @change="onGlobalCheckChange($event, 'adBudgetCheck')"> </el-checkbox>
                <span>&ensp;预算</span>
              </div>
              <span class="col-modify" @click="onAdBudgetModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>
          <template slot-scope="{ row, $index }">
            <template>
              <el-checkbox v-model="row.adBudgetCheck"></el-checkbox>
              <el-button @click="onAdBudgetModify($index)" type="text">预算：{{ row.creative_params.budget }}</el-button>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="计划出价" width="160" v-if="adBidVisible">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox v-model="tableHeaderForm.bidCheck" @change="onGlobalCheckChange($event, 'bidCheck')"> </el-checkbox>
                <span>&ensp;计划出价</span>
              </div>

              <span class="col-modify" @click="onAdBidModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>
          <template slot-scope="{ row, $index }">
            <template>
              <div class="flex flex-center">
                <el-checkbox v-model="row.bidCheck"> </el-checkbox>

                <el-button style="text-align: left" type="text" @click="onAdBidModify($index)">
                  <span>
                    <span>目标出价：</span>
                    <span>{{ row.creative_params.cpa_bid || '' }}</span>
                    <span>{{ row.creative_params.bid_num_range?.length ? row.creative_params.bid_num_range.join(' ~ ') : '' }}</span>
                    <span>元</span>
                  </span>
                  <br />
                  <span v-if="row.creative_params.roi_goal || row.creative_params.roi_bid_num_range?.length">
                    <span>ROI出价：</span>
                    <span>{{ row.creative_params.roi_goal || '' }}</span>
                    <span>
                      {{ row.creative_params.roi_bid_num_range?.length ? row.creative_params.roi_bid_num_range.join(' ~ ') : '' }}
                    </span>
                    <span>元</span>
                  </span>
                </el-button>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="抖音号">
          <template slot-scope="{ row }">
            {{ row.creative_params.native_setting ? row.creative_params.native_setting.aweme_name : '-' }}
          </template>
        </el-table-column>

        <el-table-column width="140" v-if="adAnchorRelatedTypeVisible">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox
                  v-model="tableHeaderForm.anchorRelatedTypeCheck"
                  @change="onGlobalCheckChange($event, 'anchorRelatedTypeCheck')"
                >
                </el-checkbox>
                <span>&ensp;原生锚点</span>
              </div>

              <span class="col-modify" @click="onAnchorRelatedTypeModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>

          <template slot-scope="{ row, $index }">
            <el-checkbox v-model="row.anchorRelatedTypeCheck"> </el-checkbox>
            <el-button type="text" @click="onAnchorRelatedTypeModify($index)">
              {{ row.creative_params.anchor_name || '未配置锚点' }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="落地页" width="140">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox v-model="tableHeaderForm.landingPageCheck" @change="onGlobalCheckChange($event, 'landingPageCheck')">
                </el-checkbox>
                <span>&ensp;落地页</span>
              </div>

              <span class="col-modify" @click="onAdLandingPageModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>

          <template slot-scope="{ row, $index }">
            <el-checkbox v-model="row.landingPageCheck"> </el-checkbox>
            <el-button type="text" @click="onAdLandingPageModify($index)">
              <span v-if="getLandingPageLen(row)">{{ row.creative_params.web_url_pack_name }}（{{ getLandingPageLen(row) }}）</span>
              <span v-else>未配置落地页</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="创意素材" min-width="320" v-if="isPromotionMaterial">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox v-model="tableHeaderForm.creativeCheck" @change="onGlobalCheckChange($event, 'creativeCheck')"> </el-checkbox>
                <span>&ensp;创意素材</span>
              </div>
              <span class="col-modify" @click="onCreativeModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>
          <template slot-scope="{ row }">
            <div class="material-list">
              <el-checkbox v-model="row.creativeCheck"> </el-checkbox>
              <span>&ensp;</span>

              <div class="material-box" :title="item.name" v-for="(item, index) in row.creative_params.preview_list" :key="index">
                <el-tag class="badge">{{ item.badge }}</el-tag>
                <div class="img-box">
                  <img :class="item.vertical ? 'vertical' : 'horizontal'" :src="item.url" alt="" />
                </div>

                <p class="material-name">{{ item.name }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="文案包" width="200" v-if="isPromotionMaterial">
          <template slot="header" slot-scope="scope">
            <div :class="scope.a" class="custom-column-header">
              <div>
                <el-checkbox v-model="tableHeaderForm.descriptionCheck" @change="onGlobalCheckChange($event, 'descriptionCheck')">
                </el-checkbox>
                <span>&ensp;文案包</span>
              </div>
              <span class="col-modify" @click="onDescriptionModify()">
                <i class="el-icon-edit"></i>
                修改
              </span>
            </div>
          </template>

          <template slot-scope="{ row, $index }">
            <el-checkbox v-model="row.descriptionCheck"> </el-checkbox>
            <span>&ensp;</span>
            <el-button type="text" @click="onDescriptionModify($index)" v-if="row.creative_params.title_material_list">
              {{ row.creative_params.title_pack_name }}（{{ row.creative_params.title_material_list.length }}）
            </el-button>
            <span v-else></span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="{ $index, row }">
            <el-button v-if="!row.planRowDisabled" type="text" @click="onPreviewTableRowRemove($index)">删除</el-button>
            <el-button type="text" @click="onPreviewTableRowCopy($index)">复制</el-button>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <BudgetModifyModal
      title="修改项目预算"
      :visible.sync="globalModal.showGlobalBudgetModify"
      :current-row="currentModifyTableRow"
      @confirm="onProjectBudgetModifyConfirm"
      @cancel="onModifyModalCancel"
    ></BudgetModifyModal>

    <AdBudgetModifyModal
      title="修改预算"
      :visible.sync="globalModal.showGlobalAdBudgetModify"
      :current-row="currentModifyTableRow"
      @confirm="onAdBudgetModifyConfirm"
      @cancel="onModifyModalCancel"
    ></AdBudgetModifyModal>

    <AdTargetModifyModal
      title="修改定向"
      :visible.sync="globalModal.showGlobalTargetModify"
      :target-list="targetings"
      @confirm="onTargetModifyConfirm"
      @cancel="onModifyModalCancel"
    ></AdTargetModifyModal>

    <AdBidModifyModal
      title="修改出价"
      :visible.sync="globalModal.showGlobalAdBidModify"
      :current-row="currentModifyTableRow"
      @confirm="onAdBidModifyConfirm"
      @cancel="onModifyModalCancel"
    ></AdBidModifyModal>

    <LandingPagePackageModal
      v-model="globalModal.showGlobalLandingPageModify"
      :limit="1"
      :game-id="gameId"
      :op-id="opId"
      :media-id="MEDIAS.TOUTIAO"
      @confirm="onAdLandingPageModifyConfirm"
    />

    <AdCreativeModifyModal
      title="修改创意组"
      width="980px"
      :visible.sync="globalModal.showGlobalCreativeModify"
      :creative-list="creatives"
      :max-count="maxCount"
      @confirm="onCreativeModifyConfirm"
      @cancel="onModifyModalCancel"
    ></AdCreativeModifyModal>

    <AdAnchorRelatedTypeModal
      title="选择原生锚点"
      :current-row="currentModifyTableRow"
      :visible.sync="globalModal.showGlobalAnchorRelatedTypeModify"
      @confirm="onAnchorRelatedTypeModifyConfirm"
      @cancel="onModifyModalCancel"
    >
    </AdAnchorRelatedTypeModal>

    <TitleSelectModal v-model="globalModal.showGlobalDescriptionModify" :op-id="opId" :limit="1" @confirm="onDescriptionModifyConfirm" />
  </div>
</template>

<script setup>
import { ref, nextTick, toRefs, computed, inject, watch } from 'vue'
import { clone } from '@/common/js/just.js'
import BudgetModifyModal from './components/project-budget.vue'
import AdBudgetModifyModal from './components/ad-budget.vue'
import AdTargetModifyModal from './components/ad-target.vue'
import AdBidModifyModal from './components/ad-bid.vue'
import AdCreativeModifyModal from './components/ad-creative.vue'
import AdAnchorRelatedTypeModal from './components/ad-anchor-related-type.vue'
import LandingPagePackageModal from '@/views/create/bytedance/components/creative/components/landing-pages/index.vue'
import TitleSelectModal from '@/components/title-selector/title-selector-modal.vue'
import { MEDIAS } from '@/common/js/constants.js'
import {
  EXTERNAL_ACTION_LIST,
  DEEP_BID_TYPE_LIST,
  DEEP_EXTERNAL_ACTION_LIST,
  ANCHOR_RELATED_TYPE,
  DELIVERY_MODE,
  MATERIAL_STYLE
} from '../../consts/index.js'
import { useOptimizeGoalRelative } from '../../hooks/useOptimizeGoal.js'
import {
  getDefaultCheckStates,
  getDefaultModalStates,
  useTableStates,
  useBudget,
  useTargeting,
  useAdBudget,
  useAdBid,
  useAdLandingPage,
  useCreative,
  useDescription,
  useAnchorRelatedType
} from './useTablePreview.js'
// eslint-disable-next-line
const emits = defineEmits(['update-table-data', 'update-table-form'])
// eslint-disable-next-line
const props = defineProps({
  tableData: Array,
  tableForm: Object,
  // 原始的定向包数据，用于修改定向包时作为选择列表
  targetings: Array,
  // 原始的创意组数据，用于修改创意组时作为选择列表
  creatives: Array,
  activeAccount: Number
})
const { tableData, tableForm } = toRefs(props)
const ref_Table = ref(null)
const { opId, getGameId } = inject('localStates')
const { configForm } = inject('configForm')
const { isV3 } = inject('bytedanceVersion', { isV3: computed(() => false) })
const gameId = computed(() => getGameId())
const projectForm = computed(() => configForm.value.project)
const planForm = computed(() => configForm.value.plan)
const { adBidVisible, adBudgetVisible } = useOptimizeGoalRelative(projectForm)

const isPromotionMaterial = computed(() => planForm.value.materials_type === MATERIAL_STYLE.PROMOTION_MATERIALS)
const maxCount = computed(() => (isV3.value ? 800 : configForm.value.project?.delivery_mode === DELIVERY_MODE.PROCEDURAL ? 30 : 10))

const { globalModal, tableHeaderForm, currentModifyTableRow, onGlobalCheckChange, onTableRowCheckChange } = useTableStates(
  tableData,
  tableForm,
  emits
)
// 切换账号时，清空表格头的勾选状态
watch(
  () => props.activeAccount,
  () => (tableHeaderForm.value = getDefaultCheckStates())
)

const { onBudgetModify, onProjectBudgetModifyConfirm } = useBudget(tableData, emits, onModifyModalCancel)
const { onTargetModify, onTargetModifyConfirm } = useTargeting(tableData, emits, onModifyModalCancel)
const { onAdBudgetModify, onAdBudgetModifyConfirm } = useAdBudget(tableData, emits, onModifyModalCancel)
const { onAdBidModify, onAdBidModifyConfirm } = useAdBid(tableData, emits, onModifyModalCancel)
const { onAdLandingPageModify, onAdLandingPageModifyConfirm } = useAdLandingPage(tableData, emits, onModifyModalCancel)
const { onCreativeModify, onCreativeModifyConfirm } = useCreative(tableData, emits, onModifyModalCancel)
const { onDescriptionModify, onDescriptionModifyConfirm } = useDescription(tableData, emits, onModifyModalCancel)
const { adAnchorRelatedTypeVisible, onAnchorRelatedTypeModify, onAnchorRelatedTypeModifyConfirm } = useAnchorRelatedType(
  tableData,
  emits,
  onModifyModalCancel
)

function resetModifyForm() {
  currentModifyTableRow.value = null
  tableHeaderForm.value = getDefaultCheckStates()
  const newData = tableData.value.map((item) => {
    return {
      ...item,
      ...getDefaultCheckStates()
    }
  })
  emits('update-table-data', newData)
}
function onModifyModalCancel() {
  globalModal.value = getDefaultModalStates()
  nextTick(resetModifyForm)
}

function getAdCount() {
  const checkedRows = tableData.value.filter((row) => row.creative_params.check !== false)
  return `${checkedRows.length}/${tableData.value.length}`
}

const onAllCheckChange = (checked) => {
  const newData = tableData.value.map((row) => {
    return {
      ...row,
      isCheck: row.planRowDisabled ? true : checked
    }
  })
  emits('update-table-data', newData)
}

/**
 * @description: 判断每个项目下的第一个广告不能修改广告名称
 * @param {*} row
 * @param {*} index
 */
function planNameEditable(row, index) {
  const { rowIndex } = tableGroups.value[row.temp_project_name] || {}
  return rowIndex !== index
}

const onPreviewTableRowRemove = (index) => {
  const newData = clone(tableData.value)
  newData.splice(index, 1)
  emits('update-table-data', newData)
}
const onPreviewTableRowCopy = (index) => {
  const newData = clone(tableData.value)
  const newRow = clone(newData[index])
  if (isV3.value) {
    newRow.campaign_params.project_name += '_复制'
    newRow.inner_plan_params.plan_name = newRow.campaign_params.project_name
    newRow.temp_project_name = `${newRow.temp_project_name}_copy_${Date.now()}`
  } else {
    newRow.inner_plan_params.plan_name += '_复制'
  }
  delete newRow.planRowDisabled
  newData.splice(index + 1, 0, newRow)
  emits('update-table-data', newData)
}

const getLandingPageLen = (row) => {
  const { web_url_material_list } = row.creative_params
  return web_url_material_list?.length || null
}
/**
 * @description: 表格合并单元格辅助计算属性
 */
const tableGroups = computed(() => {
  const groups = {}
  tableData.value.forEach((row, rowIndex) => {
    const tempName = row.temp_project_name
    const group = groups[tempName]
    if (!group) {
      groups[tempName] = {
        rowIndex,
        num: 1
      }
    } else {
      groups[tempName] = Object.assign({}, group, {
        num: group.num + 1
      })
    }
  })
  return groups
})

/**
 * @description: 表格合并
 */
function tableSpanMethod({ row, column, rowIndex, columnIndex }) {
  if (isV3.value) return
  const group = tableGroups.value[row.temp_project_name]
  if ([0, 1, 2, 3].includes(columnIndex)) {
    if (rowIndex === group.rowIndex) {
      return {
        // group.num 在computed: tableGroups中计算得出
        rowspan: group.num,
        colspan: 1
      }
    } else {
      return {
        rowspan: 0,
        colspan: 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-column-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .col-modify {
    cursor: pointer;
  }
}
.flex {
  display: flex;
}
.flex-center {
  align-items: center;
}
.is-edit {
  display: none;
  &.flex {
    display: flex;
  }
  ::v-deep .el-input__inner {
    padding: 0 5px;
  }
}
.el-icon-edit-outline {
  visibility: hidden;
  &.global {
    visibility: visible;
  }
}
.table-col-header {
  display: flex;
  align-items: center;
  &.justify {
    justify-content: space-between;
  }
  h5 {
    font-size: 14px;
    margin-right: 20px;
  }
}

.el-table {
  .project-name {
    margin-top: 10px;
    &-editing {
      display: flex;
    }
  }

  .material-list {
    display: flex;
    justify-content: flex-start;
    overflow: auto;
    overflow-y: hidden;
    width: 100%;
    padding-bottom: 4px;

    .material-box {
      // flex-basis: 110px;
      min-width: 110px;
      width: 110px;
      height: 78px;
      margin-right: 5px;
      text-align: center;
      position: relative;

      .img-box {
        border-radius: 4px;
        overflow: hidden;
        height: 62px;
        background: #eee;
        .horizontal {
          width: 100%;
        }
        .vertical {
          height: 100%;
        }
      }
      .material-name {
        width: 110px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .badge {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        font-size: 12px;
        transform: scale(0.8);
        transform-origin: 0 0;
      }
    }
  }
}
</style>
